import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/design-system";
import { Feedback } from "@/components/workflow/shared";
import { errorMessage } from "@/lib/api";

export function DeleteAction({ kind, name, remove, destination, message }: {
  kind: string; name: string; remove: () => Promise<unknown>; destination: string; message: string;
}) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const lock = useRef(false);
  async function confirm() {
    if (lock.current) return;
    lock.current = true; setBusy(true); setError("");
    try {
      await remove();
      navigate(destination, { replace: true, state: { message } });
    } catch (cause) {
      setError(errorMessage(cause, "Brisanje nije uspjelo. Pokušajte ponovno."));
    } finally { lock.current = false; setBusy(false); }
  }
  return <><Button variant="destructive" onClick={() => { setError(""); setOpen(true); }}>Obriši</Button>
    {open && <Dialog title={`Obriši ${kind}`} onClose={() => { if (!lock.current) setOpen(false); }}>
      <p className="mb-2 break-words font-semibold">{name}</p>
      <p>Trajno brisanje nije moguće poništiti. Brisanje ostaje zabilježeno u audit dnevniku.</p>
      <Feedback error={error} />
      <div className="mt-4 flex flex-wrap gap-3">
        <Button variant="secondary" disabled={busy} onClick={() => setOpen(false)}>Odustani</Button>
        <Button variant="destructive" disabled={busy} onClick={() => void confirm()}>{busy ? "Brisanje…" : "Potvrdi brisanje"}</Button>
      </div>
    </Dialog>}
  </>;
}
